export default {
  keepAlive: true,
}
